import {createContext, PropsWithChildren, useContext, ReactElement} from 'react';

import {FilterTopbarItem} from 'filters/features/FilterTopbar/types';

type FilterTopbarState = {
  title: string;
  items: FilterTopbarItem[];
  useEndAdornment?: () => ReactElement | null;
};

const FilterTopbarContext = createContext<FilterTopbarState>(null as never);

export const useFilterTopbarContext = () => {
  const context = useContext(FilterTopbarContext);

  if (!context) {
    throw new Error('useFilterTopbarContext must be used within a FilterTopbarProvider');
  }

  return context;
};

export const FilterTopbarProvider = ({children, ...value}: PropsWithChildren<FilterTopbarState>) => {
  return <FilterTopbarContext.Provider value={value}>{children}</FilterTopbarContext.Provider>;
};
